// Virtual devices (Teams classic driver, VDI/remote desktop, virtual cables) disrupt
// NexGen audio even when they are the OS default. MediaDeviceInfo has no "virtual" flag,
// so detection is label-based; patterns are specific to avoid false positives like
// "Virtual Surround".
const VIRTUAL_AUDIO_DEVICE_LABEL_PATTERNS: RegExp[] = [
  /\bteams\s*audio\b/i,
  /\bmsteams\s*audio/i, // no trailing \b: "MSTeamsAudioDevice" continues in camelCase
  /\bcitrix\b/i,
  /\bhdx\b/i,
  /\bremote audio\b/i,
  /\bvirtual (audio )?cable\b/i,
  /\bvb-?cable\b/i,
  /\bvoicemeeter\b/i,
  /\bblackhole\b/i,
  /\bloopback\b/i,
  /\bsoundflower\b/i,
  /\bzoom\s*audio/i, // no trailing \b: "ZoomAudioDevice"
  /\bnx_?audio/i, // NoMachine "nx_audioin"
  /\bvirtual (microphone|mic|speaker|output|input)\b/i,
];

export function isVirtualAudioDevice(device: Pick<MediaDeviceInfo, 'kind' | 'label'>): boolean {
  // Cameras never match — virtual audio patterns must not reject video devices.
  if (device?.kind !== 'audioinput' && device?.kind !== 'audiooutput') return false;
  const label = device?.label?.trim();
  if (!label) return false; // unlabeled before permission granted — cannot classify
  return VIRTUAL_AUDIO_DEVICE_LABEL_PATTERNS.some((pattern) => pattern.test(label));
}

export function filterVirtualAudioDevices<T extends MediaDeviceInfo>(devices: T[]): T[] {
  return devices.filter((device) => {
    if (isVirtualAudioDevice(device)) {
      return false;
    }
    return true;
  });
}
